export const BicycodeIcon = ({ size, className }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<g opacity="0.5">
				<rect width="40" height="40" rx="20" fill="#1B1464" />
				<path
					d="M29.5776 26.2389L32 27.408C29.7286 31.0655 25.754 33.4409 21.0602 33.4409C13.6031 33.4391 8 27.408 8 19.9796C8 12.5513 13.6031 6.55908 21.0602 6.55908C25.754 6.55908 29.7286 8.93438 32 12.553L29.5776 13.7593C27.7608 11.0072 24.6938 9.23506 21.0602 9.23506C15.0789 9.23506 10.8007 14.0599 10.8007 19.9796C10.8007 25.8993 15.0789 30.7613 21.0602 30.7613C24.6938 30.7613 27.7608 28.9892 29.5776 26.2371V26.2389ZM20.9466 17.9828C22.1205 17.9828 23.028 18.8884 23.028 20.0557C23.028 21.223 22.1187 22.1285 20.9466 22.1285C19.7745 22.1285 18.8652 21.1858 18.8652 20.0557C18.8652 18.9255 19.8118 17.9828 20.9466 17.9828Z"
					fill="#DDE3EE"
				/>
			</g>
		</svg>
	)
}
